// Import du manifest
import moduleManifest from '../package.json'

// Import du gfi-mapviewer
import Mapviewer from './js/core/core'

// Import de toutes les extensions du core
import CommonLayer from './js/commonLayer/common-layer'
import BackgroundLayer from './js/bglayer/background-layer'
import DataLayer from './js/datalayer/data-layer'
import Drawing from './js/drawing/drawing'
import Tooltips from './js/tooltips/mapviewer-tooltips'
import * as Services from './js/tools/mapviewer-services'
import Geocodage from './js/tools/mapviewer-geocodage'
import Filter from './js/filter/mapviewer-filter'
import LabelFeature from './js/labelFeature/label-feature'
import SketchLayer from './js/sketchLayer/sketch-layer'
import GeoLocation from './js/tools/mapviewer-geoLocation'
import OlUtils from './js/utils/ol-utils'

import * as style from './js/style-literal/'

// Import des constantes de cache
import {
  CACHE_TTL_UNLIMITED,
  CACHE_TTL_ONE_MONTH,
  CACHE_STRATEGY_CACHE_FIRST,
  CACHE_STRATEGY_NETWORK_FIRST,
} from './js/services/tile-cache-manager'

// Import du style
import 'ol/ol.css'
// TODO reduire ol-ext au css des controle utilisés, exemple :  import 'ol-ext/control/Search.css';
import 'ol-ext/dist/ol-ext.css'

import './style/mapviewer.styl'

// Export des élements de la lib
export {
  moduleManifest,
  Mapviewer,
  CommonLayer,
  BackgroundLayer,
  DataLayer,
  Drawing,
  Tooltips,
  Services,
  Geocodage,
  Filter,
  LabelFeature,
  SketchLayer,
  GeoLocation,
  OlUtils,
  style,
  // Constantes de cache
  CACHE_TTL_UNLIMITED,
  CACHE_TTL_ONE_MONTH,
  CACHE_STRATEGY_CACHE_FIRST,
  CACHE_STRATEGY_NETWORK_FIRST
}
